module.exports = __webpack_public_path__ + "img/youtube.4fb2f08c.svg";